import React from 'react'
import { Badge, Card, Flex, List, Typography } from 'antd'
import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Site } from '../../site/site'
import { hasTodo, isError } from '../../site/components/sites-overview'

/**
 * The company's websites at a glance: whether the chat is live and how many chats it had this week.
 */
export function DashboardSitesCard({ sites }: { sites: Site[] }) {
    const { t } = useTranslation()

    return (
        <Card
            title={t('Websites')}
            className="w-full"
            extra={<Link to="/websites">{t('All websites')}</Link>}
        >
            <List
                dataSource={sites}
                renderItem={(site) => (
                    <List.Item>
                        <Link
                            to="/websites/$siteId"
                            params={{ siteId: site.id }}
                            className="flex min-w-0 flex-1 flex-col"
                        >
                            <Typography.Text
                                strong
                                ellipsis
                            >
                                {site.name}
                            </Typography.Text>
                            <Typography.Text
                                type="secondary"
                                className="text-xs"
                            >
                                {t('{{count}} chats in the last 7 days', { count: site.chatsLast7Days ?? 0 })}
                            </Typography.Text>
                        </Link>
                        <Flex className="shrink-0">
                            {hasTodo(site) ? (
                                <Badge
                                    status={isError(site) ? 'error' : 'warning'}
                                    text={t('To do')}
                                />
                            ) : (
                                <Badge
                                    status="success"
                                    text={t('Live')}
                                />
                            )}
                        </Flex>
                    </List.Item>
                )}
            />
        </Card>
    )
}
